// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"528":"component---src-pages-authorization-jsx","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"528":"f4bed824768868b96467","532":"7a7928b85425adb725fe","678":"efd463edced39708aa3f","883":"45b2887e328ccbb91133"}[chunkId] + ".js";
};